/**
 * Meta info displayed on the form items
 */
import { Result } from "nutso";
// TODO:SCSS import "../scss/_form.scss"

type Props<T> = {
  validation?: Result<T>;
  helpText?: string;
};

export const FormMeta = <T,>({ validation, helpText }: Props<T>) => {
  //
  /*
  const renderErrorMessage = () => {
    if (!validation?.errorMessage) return;
    return <div className="error">{validation.errorMessage}</div>;
  };
 */
  const renderHelpText = () => {
    if (!helpText) return;
    return <div className="help">{helpText}</div>;
  };

  //const error = renderErrorMessage();
  const help = renderHelpText();

  
  if (help) {
    return (
      <div className="meta">
        {help}
      </div>
    );
  }
  return null;
};